<template>
  <div class="container">
    <ElectricityPrice />
    <WaterPrice />
  </div>
</template>

<script>
import ElectricityPrice from "./children/electricityPrice.vue";
import WaterPrice from "./children/waterPrice.vue";
export default {
  components: { ElectricityPrice, WaterPrice },
};
</script>

<style scoped lang='less'>
.container {
  display: flex;
  padding: 20px;
  & > div {
    flex: 1;
  }
}
</style>